module.exports = __webpack_public_path__ + "static/media/star_FC4491.5a4f83a2.svg";